import { render } from "./SkyTextarea.vue?vue&type=template&id=671e37de&scoped=true"
import script from "./SkyTextarea.vue?vue&type=script&lang=js"
export * from "./SkyTextarea.vue?vue&type=script&lang=js"

import "./SkyTextarea.vue?vue&type=style&index=0&id=671e37de&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-671e37de"]])

export default __exports__